// Store the origin path before authentication to redirect back after login
export const ORIGIN_URL_KEY = 'origin-url';

export function checkPathAndStoreOrigin() {
  const { pathname, search, hash } = window.location;
  // Don't store auth-related routes — they aren't valid destinations to return to.
  const pathsToExclude = ['/auth', '/login'];
  const shouldExclude = pathsToExclude.some((p) => pathname.endsWith(p));

  if (!shouldExclude) {
    // Preserve the full deep link (path + query + hash), e.g. /regulations/:id/:tab
    window.localStorage.setItem(ORIGIN_URL_KEY, `${pathname}${search}${hash}`);
  }
}
